import axios from "axios";

export default {
  state: {
    pricelists: [],
  },

  mutations: {
    SET_PRICELIST(state, { data }) {
      state.pricelists = data;
    },
    UPDATE_PRICELIST(state, updated) {
      if (!state.pricelists.data) return;

      const index = state.pricelists.data.findIndex(
        (pricelist) => pricelist.id === updated.id
      );

      if (index !== -1) {
        state.pricelists.data.splice(index, 1, updated);
      }
    },
  },

  actions: {
    async fetchPricelists({ commit }, { page = 1, search = "" } = {}) {
        try {
          const response = await axios.get("/api/pricelists", {
              params: {
                page: page,
                search: search,
              },
          });

          commit("SET_PRICELIST", {
              data: response.data,
          });

          return response;
        } catch (error) {
          throw error;
        }
    },

    async toggleIsMSRP({ commit }, id) {
        try {
          const { data: response } = await axios.post(
            `/api/pricelists/${id}/settings/msrp`
          );

          commit("UPDATE_PRICELIST", {
              data: response.data,
          });

          return response;
        } catch (error) {
          throw error;
        }
    },

    async toggleIsMAP({ commit }, id) {
        try {
          const { data: response } = await axios.post(
            `/api/pricelists/${id}/settings/map`
          );

          commit("UPDATE_PRICELIST", {
              data: response.data,
          });

          return response;
        } catch (error) {
          throw error;
        }
    },

    async toggleIsMTP({ commit }, id) {
      try {
        const { data: response } = await axios.post(
          `/api/pricelists/${id}/settings/mtp`
        );

        commit("UPDATE_PRICELIST", {
            data: response.data,
        });

        return response;
      } catch (error) {
        throw error;
      }
    },
  },

  getters: {
    getPricelists: (state) => state.pricelists,
  },
};
